var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.25C14.7191 2.25387 11.5738 3.5589 9.25384 5.87883C6.93392 8.19875 5.62888 11.3441 5.62501 14.625C5.62108 17.3061 6.49687 19.9145 8.11801 22.05C8.11801 22.05 8.45551 22.4944 8.51064 22.5585L18 33.75L27.4939 22.5529C27.5434 22.4933 27.882 22.05 27.882 22.05L27.8831 22.0466C29.5035 19.9121 30.3789 17.3049 30.375 14.625C30.3711 11.3441 29.0661 8.19875 26.7462 5.87883C24.4263 3.5589 21.2809 2.25387 18 2.25ZM18 19.125C17.11 19.125 16.24 18.8611 15.4999 18.3666C14.7599 17.8721 14.1831 17.1693 13.8426 16.3471C13.502 15.5248 13.4128 14.62 13.5865 13.7471C13.7601 12.8742 14.1887 12.0724 14.818 11.443C15.4474 10.8137 16.2492 10.3851 17.1221 10.2115C17.995 10.0378 18.8998 10.1269 19.7221 10.4675C20.5444 10.8081 21.2472 11.3849 21.7416 12.1249C22.2361 12.865 22.5 13.735 22.5 14.625C22.4985 15.818 22.0239 16.9617 21.1803 17.8053C20.3368 18.6489 19.193 19.1235 18 19.125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c35841d4ec94af7ac74721985f051c7a.svg";
export { ForwardRef as ReactComponent };